import { useEffect, useState } from "react";

/** Matches Tailwind `lg` — mobile/tablet picker sheets below this width. */
export const MOBILE_PICKER_MEDIA_QUERY = "(max-width: 1023px)";

/** Matches Tailwind `max-md` — phone-width lists and compact sticky chrome. */
export const MD_DOWN_MEDIA_QUERY = "(max-width: 767px)";

function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = (): void => setMatches(media.matches);
    onChange();
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function useIsMobile(): boolean {
  return useMatchMedia(MOBILE_PICKER_MEDIA_QUERY);
}

export function useIsMdDown(): boolean {
  return useMatchMedia(MD_DOWN_MEDIA_QUERY);
}
